import React from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    content: string
    close(): void
}

const FreeAccountDataLimitUpgradeDialog: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            <Dialog
                actions={
                    <FlatButton
                        data-intercom-target={"Btn-UpgradeFreeAccountDataLimitUpgradeDialog"}
                        label={strings.Upgrade.toUpperCase()}
                        primary
                        keyboardFocused
                        onClick={() => {
                            AppStateStore.openAccountBillingDrawer()
                            props.close()
                        }}
                    />
                }
                modal
                open
                onRequestClose={props.close}
            >
                {props.content}
            </Dialog>
        </div>
    );
}

export default FreeAccountDataLimitUpgradeDialog